export default __webpack_public_path__ + "static/media/searchIcon.41e9645a.svg";